<template>
    <DFormRow
        :label="__('customers.customers.payment_method')"
        :is-required="true"
        :error="errors.payment_method"
    >
        <div
            role="group"
            class="form-group"
        >
            <DSelect
                id="payment_method"
                :model-value="modelValue"
                :options="availablePaymentMethods"
                :placeholder="__('customers.customers.select_payment_method')"
                @update:modelValue="emit('update:modelValue', $event)"
                @update:checked="paymentMethodChanged"
            />
        </div>
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: String,
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    availablePaymentMethods: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['paymentMethodChanged', 'update:modelValue'])

function paymentMethodChanged (value) {
    emit('paymentMethodChanged', value)
}
</script>
